/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';
import { cssTransition,toast } from 'react-toastify';

import BackImage from 'components/BackImage';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

import 'react-toastify/dist/ReactToastify.css';

import { storageKeys, userKeys } from 'settings';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

export default class MagicLinkView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      logo: null,
    };
  }
  
  componentDidMount() {
    this.loadData();
    this.getAppInfo();
  }

  getAppInfo = async () => {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        logo: appInfo.logoWhite,
      });
    }
  };

  loadData() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (token === null) {
      StorageHandler.removeKeys(userKeys);
      // Toast error. Login Failed
      // TODO not found
      toast.error(i18n.translate('loginScreen.version2.toastMessage.magicLinkError'), {
        position: 'top-center',
        transition: Zoom,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      window.setTimeout(() => {
        window.location.href = '/login';
      }, 10000);

      return;
    }

    if (typeof token === 'undefined') {
      toast.error(i18n.translate('loginScreen.version2.toastMessage.magicLinkError1'), {
        position: 'top-center',
        transition: Zoom,
        autoClose: 20000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      window.setTimeout(() => {
        window.location.href = '/login';
      }, 10000);
    } else {
      DataHandler.matchAppId().then((appId) => {
        APIHandler.loginMagicLink(token).then((res) => {
          if (res.error) {
            StorageHandler.removeKeys(userKeys);
            // Toast error. Login Failed
            // TODO not found
            toast.error(i18n.translate('loginScreen.version2.toastMessage.magicLinkError2'), {
              position: 'top-center',
              transition: Zoom,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            window.setTimeout(() => {
              window.location.href = '/login';
            }, 10000);
          } else if (!res.access_token) {
            StorageHandler.removeKeys(userKeys);
            toast.error(i18n.translate('loginScreen.version2.toastMessage.magicLinkError2'), {
              position: 'top-center',
              transition: Zoom,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            window.setTimeout(() => {
              window.location.href = '/login';
            }, 10000);
          } else {
            StorageHandler.save(storageKeys.accessToken, res.access_token);
            StorageHandler.save(storageKeys.refreshToken, res.refresh_token, res.expires_in);

            APIHandler.getUser(appId, res.access_token)
              .then((user) => {
                if (Object.keys(user).length > 0) {

                  APIHandler.getUserOld(appId, user.email)
                  .then((registeredForApp) => {
                    StorageHandler.save(storageKeys.user, user, 30 * 24 * 60 * 60 * 1000); // 30 days in ms
                    // console.log(registeredForApp);
                    if (registeredForApp && registeredForApp.response.sales_companion_registered === null) {
                      window.location.replace('/login/quick-register');
                    } else if (registeredForApp && registeredForApp.response.sales_companion_registered === 'null') {
                      window.location.replace('/login/quick-register');
                    } else {
                      window.location.replace('/');
                    } 
                  });
                }
              });
          }
        });
      });
    }
  }

  render() {
    const { logo } = this.state;
    return (
      <div className="magicLinkView">
        <BackImage darken />
        <div className="sso-content">
          <img src={logo} className="logo" alt="Logo" />
          <span className="spinner"><FontAwesomeIcon icon={['fas', 'circle-notch']} spin /></span>
          <p>{i18n.translate('loginScreen.version2.toastMessage.magicLinkMessage')}</p>
        </div>
      </div>
    );
  }
}
